import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { 
  createProviderUser, 
  CreateProviderUserInput, 
  CreateProviderUserResponse 
} from '@/services/providerUserService';

interface ProviderUserState {
  loading: boolean;
  error: string | null;
  success: boolean;
  createdUser: CreateProviderUserResponse | null;
}

const initialState: ProviderUserState = {
  loading: false,
  error: null,
  success: false,
  createdUser: null
};

// Create async thunk for creating provider user
export const createProviderUserThunk = createAsyncThunk<
  CreateProviderUserResponse,
  CreateProviderUserInput
>(
  'providerUser/createProviderUser',
  async (input, { rejectWithValue }) => {
    try {
      const response = await createProviderUser(input);
      return response;
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to create provider user');
    }
  }
);

// Create the slice
const providerUserSlice = createSlice({
  name: 'providerUser',
  initialState,
  reducers: {
    resetProviderUserState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.createdUser = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(createProviderUserThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(createProviderUserThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.createdUser = action.payload;
      })
      .addCase(createProviderUserThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        state.success = false;
      });
  }
});

export const { resetProviderUserState } = providerUserSlice.actions;
export default providerUserSlice.reducer;
